import { ActionsColumn } from '@otp/ui';
import { Edit, MinusOutlined } from '@otp/icons';
import { useState } from 'react';
import { VideoResourceItem } from '../../types';
import { EditDescriptionModal } from '../../edit-description-modal';

type ActionsFieldProps = {
  video: VideoResourceItem;
  onDelete: (item: VideoResourceItem) => void;
  onChange: (
    updatedItem: VideoResourceItem,
    { description }: { description: string },
  ) => void;
};

export const ActionsField = ({
  video,
  onDelete,
  onChange,
}: ActionsFieldProps) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      <ActionsColumn
        icons={[
          {
            icon: <Edit />,
            onClick: () => setIsEditing(true),
          },
          { icon: <MinusOutlined />, onClick: () => onDelete(video) },
        ]}
      />
      {isEditing && (
        <EditDescriptionModal
          open={isEditing}
          onClose={() => setIsEditing(false)}
          onSave={({ description }) => onChange(video, { description })}
          defaultValues={{ description: video.description || '' }}
        />
      )}
    </>
  );
};
